import _regeneratorRuntime from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import applyForm from "./applyForm.vue";
import { getCustomerList } from '@/views/cardSystem/customer/api/index';
import { getInitiatedByMe, submitProjectDeliveryAcceptance } from "../api";
export default {
  components: {
    applyForm: applyForm
  },
  data: function data() {
    return {
      companyList: [],
      searchForm: {
        status: [],
        type_of_demand: [],
        customer_id: null,
        pageSize: 20,
        page: 1
      },
      listData: [],
      listPages: {
        currentPage: 1,
        totalCount: 0
      },
      applyFormVisible: false,
      applyFormType: 'add',
      selectedId: null
    };
  },
  created: function created() {
    this.getCompanyList();
    this.getlist();
  },
  methods: {
    getCompanyList: function getCompanyList(val) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getCustomerList({
                page_size: 200,
                name: val || '',
                is_delete: 0
              });
            case 2:
              res = _context.sent;
              _this.companyList = res.data.list;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getlist: function getlist() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getInitiatedByMe(_this2.searchForm);
            case 2:
              res = _context2.sent;
              _this2.listData = res.data.data;
              _this2.listPages = res.pages;
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 翻页
    handlePageChange: function handlePageChange(page) {
      this.searchForm.page = page;
      var dom = document.getElementById('searchDom');
      dom.scrollIntoView();
      this.getlist();
    },
    sizeChange: function sizeChange(size) {
      this.searchForm.pageSize = size;
      this.searchForm.page = 1;
      this.getlist();
    },
    resetList: function resetList() {
      this.searchForm.page = 1;
      this.getlist();
    },
    handleClose: function handleClose() {
      this.$emit('getCount');
      this.getlist();
    },
    viewDetail: function viewDetail(id) {
      this.selectedId = id;
      this.applyFormType = 'view';
      this.applyFormVisible = true;
    },
    toCreate: function toCreate() {
      this.selectedId = null;
      this.applyFormType = 'add';
      this.applyFormVisible = true;
    },
    toAgain: function toAgain(id) {
      this.selectedId = id;
      this.applyFormType = 'add';
      this.applyFormVisible = true;
    },
    toAccept: function toAccept(id) {
      var _this3 = this;
      this.selectedId = id;
      this.$confirm('确定验收通过？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.submitAcceptance();
      });
    },
    submitAcceptance: function submitAcceptance() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return submitProjectDeliveryAcceptance({
                id: _this4.selectedId
              });
            case 2:
              res = _context3.sent;
              _this4.$message.success('验收成功');
              _this4.applyFormVisible = false;
              _this4.getlist();
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  }
};